const BaseXform = require('../../base-xform');
const CStrRefXform = require('./c-str-ref-xform');

class CTxChartXform extends BaseXform {
  constructor() {
    super();

    this.map = {
      'c:strRef': new CStrRefXform(),
    };
  }

  get tag() {
    return 'c:tx';
  }

  render(xmlStream, model) {
    xmlStream.openNode(this.tag);
    this.map['c:strRef'].render(xmlStream, model);
    xmlStream.closeNode();
  }

  parseOpen(node) {
    if (this.parser) {
      this.parser.parseOpen(node);
      return true;
    }

    switch (node.name) {
      case this.tag:
        this.reset();
        break;

      default:
        this.parser = this.map[node.name];
        if (this.parser) {
          this.parser.parseOpen(node);
        }
        break;
    }
    return true;
  }

  parseText(text) {
    if (this.parser) {
      this.parser.parseText(text);
    }
  }

  parseClose(name) {
    if (this.parser) {
      if (!this.parser.parseClose(name)) {
        this.parser = undefined;
      }
      return true;
    }
    switch (name) {
      case this.tag:
        this.model = this.map['c:strRef'].model;
        return false;
      default:
        return true;
    }
  }
}

module.exports = CTxChartXform;
